import React, { useEffect, useState } from "react";
import Widgets from "../../../widgets";
import "./NationalIdList.css";
import plusIcon from "../../../Assets/Icons/PlusIcon.png";
import { useTranslation } from "react-i18next";
import Icons from "../../../Assets/Icons";
import NoData from "../../../Assets/Icons/NoData.png";
import { useDispatch, useSelector } from "react-redux";
import { getNationalIdList } from "../../../modules/NationalIdCategory/NationalIdThunk";
function NationalIdList({ setSelectedView }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const breadcrumbs = [`${t("identificationType")}`];
  const paths = ["/national-id"];
  const [searchInput, setSearch] = useState(null);
  const [articleList, setArticleList] = useState([]);
  const [NationalIdList, setNationalIdList] = useState([]);
  const selectedLanguage = useSelector((state) => state.language.language);

  useEffect(() => {
    dispatch(getNationalIdList());
  }, [dispatch, selectedLanguage]);
  //response and
  const { allNationalId, allNationalIdErr } = useSelector((state) => state.nationalId);
  const sortedNationalIds = allNationalId?.data?.categories.slice().sort((a, b) => {
    return a.title.localeCompare(b.title);
  });
  const handleButtonClick = () => {
    setSelectedView("nationalIdAdd");
  };
  const handleSearch = (query) => {
    setSearch(query);
  };
  const nationalIdCategories = allNationalId?.data?.categories || [];

  return (
    <div className="department-box article-box article-list-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("identoficationList")}</div>
      <div className="identify-search-line">
        {/* <Widgets.SearchBox onSearch={handleSearch} placeholder={"searchByArticleName"} /> */}
        <Widgets.IconButton iconSrc={plusIcon} buttonText={t("addIdentofication")} onClick={handleButtonClick} />
      </div>
      <div className="national-id-table">
        <div className="national-id-header">
          <div className="header-title">{t("idType")}</div>

          <div className="header-country">{t("idCountry")}</div>
          {/* <div className="header-country">Country</div>
          <div className="header-date">Created Date</div> */}
          {/* <div className="header-views">Views</div> */}
        </div>
        {nationalIdCategories.length > 0 ? (
          <ul className="national-id-list">
            {sortedNationalIds.map((item) => (
              <li key={item._id} className="national-id-item">
                <div className="national-id-title">{item.title}</div>
                <div className="national-id-country">{item.country.name}</div>
                {/* <div className="national-id-country">{item.country}</div>
                <div className="national-id-date">{new Date(item.createdAt).toLocaleDateString("en-GB")}</div> */}
                {/* <div className="national-id-views">
                  <img src={Icons.eye} alt="eye" />
                </div> */}
              </li>
            ))}
          </ul>
        ) : (
          <div className="no-record-container">
            <div className="no-record-icon">
              <img src={NoData} alt="No Data Found" />
            </div>
            <div className="no-record-text">{t("noRecordFound")}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NationalIdList;
